/* @flow */

import * as React from 'react';

import type {DisplayOptionEntity} from 'nutshell-core/utils';

import {Button} from '../../button';
import {EntitySelectRow} from '../../entity/entity-select-row';
import {Popover} from '../../popover';

import './potential-peeps-dropdown.module.css';

type Props = {|
    potentialPeeps: DisplayOptionEntity[],
    onSelectPeep: (DisplayOptionEntity) => void,
    popoverRef: {current: ?HTMLElement},
    canCreate: boolean,
    isPopover?: boolean,
|};

export function PotentialPeepsDropdown(props: Props) {
    const {potentialPeeps, onSelectPeep, popoverRef} = props;

    const anchorWidth =
        popoverRef && popoverRef.current && popoverRef.current.offsetWidth
            ? popoverRef.current.offsetWidth
            : 400;

    const dropdown = (
        <PotentialPeepsDropdownContent
            potentialPeeps={potentialPeeps}
            onSelectPeep={onSelectPeep}
        />
    );

    return props.isPopover ? (
        <Popover
            anchor={popoverRef.current}
            location='bottom'
            hideNub={true}
            customStyles={{
                width: anchorWidth,
                maxHeight: '300px',
                overflowY: 'auto',
            }}
            offsetY={props.canCreate ? 24 : -10}
            disableFocusTrapZone={true}
            preventLocationValidation={true}
            zIndex={99}
        >
            {dropdown}
        </Popover>
    ) : (
        dropdown
    );
}

type DropdownProps = {|
    potentialPeeps: DisplayOptionEntity[],
    onSelectPeep: (DisplayOptionEntity) => void,
|};

function PotentialPeepsDropdownContent(props: DropdownProps) {
    const {potentialPeeps, onSelectPeep} = props;

    return (
        <div styleName='container'>
            {potentialPeeps.map((peep) => (
                <div styleName={peep.isDisabled ? '' : 'result'} key={peep.id}>
                    <Button
                        variant='text-secondary'
                        onClick={() => onSelectPeep(peep)}
                        preventUnderline={true}
                        isFullWidth={true}
                        noPadding={true}
                        disabled={peep.isDisabled}
                    >
                        <EntitySelectRow entity={peep} />
                    </Button>
                </div>
            ))}
        </div>
    );
}
